// @flow
import * as React from "react";

type Props = {
  parentFilterInstance: any => mixed,
};

type State = {
  value: string,
};

export default class ProxyFloatingFilter extends React.Component<Props, State> {
  state = {
    value: "",
  };

  onChange = (event: *) => {
    const value = event.target.value || "";
    this.setState({ value }, () =>
      this.props.parentFilterInstance(filter => {
        filter.onFloatingFilterChanged({ filter: value });
      })
    );
  };

  onParentModelChanged = ({ filter: value }: *) => {
    this.setState({ value });
  };

  render() {
    return (
      <div className="ag-input-wrapper">
        <input
          className="ag-floating-filter-input"
          type="text"
          value={this.state.value}
          onChange={this.onChange}
        />
      </div>
    );
  }
}
